import styled from 'styled-components';
import {elevation, colors, demotion, setFlex, below} from '../utilities';

export const Button = styled.button`
  background-color: ${colors.blue_1};
  color: ${colors.white_1};
  border: none;
  outline: none;  
  font-size: .8rem;
  letter-spacing: .1rem;  
  border-radius: 1.2rem;
  text-decoration: none;
  cursor: pointer;
  padding: auto 2rem;
  position: relative;
  animation: moveInBottom .5s ease-out .75s;
  animation-fill-mode: backwards;
  width: ${props => props.w || "8rem" };
  height: ${props => props.h || "2rem" };
  ${props =>
    `margin: ${props.mt || 0} ${props.mr || 0} ${props.mb || 0} ${props.ml || 0}}`};  
  ${setFlex()};
  ${elevation[2]};
    
    &:hover {
      ${elevation[4]};
    }
    &:active {
      ${demotion[2]};
      color: ${colors.blue_1};
    }
    &::after {
      content: "";
      display: inline-block;
      height: 100%;
      width: 100%;
      border-radius: 100px;
      position: absolute;
      top: 0;
      left: 0;
      z-index: -1;
      transition: all .4s;
    }
    &:hover::after {
      transform: scaleX(1.4) scaleY(1.6);
      opacity: 0;
    }

    @keyframes moveInBottom {
      0% {
        opacity: 0;
        transform: translateY(30px);
      }
  
      100% {
        opacity: 1;
        transform: translate(0);
      }
    }

`;

export const TopBarButton = styled(Button)`
  color: ${colors.white_1};
  border-radius: .4rem;
  width: 6.3rem;
  height: 1.7rem;

`;

export const DownloadButton = styled(Button)`  
  color: ${colors.white_1};
  border-radius: .4rem;
  width: 13rem;
  height: 5rem;
`;


export const SliderLink = styled(Button)`
  width: 15rem;
  height: 2.5rem;            
  z-index: 100;
  margin: 2rem auto;

  &:hover {
    transform: translateY(-4px);
  }
  &:active {
    transform: translateY(-1px);
  }
  &::after {
    background-color: ${colors.blue_1};
  }

  a{
    color: ${colors.white_1};
    width: 100%;
    text-decoration: none;
    font-size: 1.2rem;
    font-weight: 600;
    letter-spacing: .3rem; 
  }

  ${below.md`
    width: 15rem;
  `}

  ${below.sm`
      width: 15rem;
   `}
`;

export const AuthButton = styled(Button)`
  margin: 1rem auto;
  margin-top: 2rem;
  color: ${colors.white_1};
`;
